import React, { useEffect, useState } from "react";
import { getAdminData } from "../services/api";
import { useNavigate } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Alert } from "../components/ui/alert";
import Navbar from "../components/ui/Navbar";

const AdminPage = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    if (!token || user.role !== "admin") {
      navigate("/login");
      return;
    }

    getAdminData(token)
      .then((res) => setData(res))
      .catch((err) => setError(err.message));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 pt-20 md:pt-28 w-full">
      <Navbar />

      <div className="w-full flex justify-center">
        <Card className="p-6 md:p-10 shadow-md bg-white">
          <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
            Panel de Administración 🦾
          </h1>

          {error && (
            <Alert variant="destructive" className="mb-4">
              <p className="text-sm text-red-600">{error}</p>
            </Alert>
          )}

          {data ? (
            <div className="bg-gray-100 p-4 rounded-md text-sm md:text-base overflow-x-auto">
              <pre>{JSON.stringify(data, null, 2)}</pre>
            </div>
          ) : (
            <p className="text-gray-500 text-center py-6">Cargando datos...</p>
          )}
        </Card>
      </div>
    </div>
  );
};

export default AdminPage;
